var _defs, _path, _g, _ellipse, _g2, _g3, _g4, _g5, _g6, _g7, _path2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cbb92aef-a4c8-4910-9d60-405154a20c92",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1116.21,
    height: 857.08,
    viewBox: "0 0 1116.21 857.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "6af09e6e-7617-4e7d-96c6-87d8d61cc5fb",
    x1: 654.32,
    y1: 613.24,
    x2: 654.32,
    y2: 117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f366e0cb-9767-4f71-a21d-568f9afb6f3a",
    x1: 475.65,
    y1: 861.71,
    x2: 475.65,
    y2: 223.28,
    xlinkHref: "#6af09e6e-7617-4e7d-96c6-87d8d61cc5fb"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "add to cart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1131.06,604.2c-1,.73-1.92,1.44-2.9,2.13a97.79,97.79,0,0,1-11.33,6.91c-20.58,10.85-45.95,16.15-70.66,19.75-55.42,8.08-112,9.65-168.34,11.19C725.6,648.36,573,652.53,421.14,642.9c-60-3.8-121.32-10.16-175.69-29.66q-11.69-4.18-22.92-9.22c-15.15-6.81-29.7-15.1-41.8-25-11.37-9.28-20.59-19.94-26.1-32.06-11.49-25.24-5.41-53.59,7.71-78.33a243.42,243.42,0,0,1,18.39-28.77c10.13-13.93,21.3-27.46,31.49-41.38C248.48,349,272.14,286.4,238.67,235.65c-9.62-14.58-23.52-27.38-31.36-42.6-10-19.47-9.23-41.09-6.05-62.09q.62-4,1.31-7.92C208,91.9,218.22,58.35,249.73,38.91c32.73-20.2,79.21-19.18,119.83-12C432.73,38.19,491,61.67,549.89,82.87s120.5,40.57,185.22,42.65c57.15,1.84,123.81-11.93,161.74-47.72,36.84-34.76,106.09-37.41,156-16.41,34.26,14.41,59.82,40.37,70.6,69.57a90.81,90.81,0,0,1,4.69,18.12,83.56,83.56,0,0,1,.84,17.09c-.15,2.82-.44,5.61-.84,8.37-8.34,57.62-68.37,103.07-104.86,154.54-17.83,25.14-30.42,55.34-18.16,82.45,18.7,41.31,83.73,56,123,86.74a92.4,92.4,0,0,1,19.3,19.8C1166.47,545.43,1159.44,582.38,1131.06,604.2Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "d00831fc-a64a-413c-b5dd-d7bd6eafa01d",
    "data-name": "flowers"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.89,346.32s-46-81.52-115.32-105c-29.09-9.86-54.48-28.4-71.84-53.74a238,238,0,0,1-21.2-38.12",
    transform: "translate(-41.9 -21.46)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.94,134.37C55.84,142,92.62,150,92.62,150s-9-36.52-16.92-44.19a19.93,19.93,0,0,0-27.76,28.6Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.75,200.46c10.79,2.14,46-11.19,46-11.19S87.3,163.51,76.5,161.37a19.93,19.93,0,0,0-7.75,39.09Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.5,272c10.4-3.6,34-32.87,34-32.87s-36.68-8.39-47.07-4.79a19.93,19.93,0,1,0,13,37.66Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,313.19c10.86-1.8,39.1-26.65,39.1-26.65s-34.73-14.47-45.59-12.68A19.93,19.93,0,0,0,214,313.19Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.39,160.73c0,11-19.9,42.93-19.9,42.93s-19.94-31.91-19.95-42.91a19.93,19.93,0,1,1,39.85,0Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.07,210c-3.29,10.5-31.84,35-31.84,35S184.75,208.55,188,198a19.93,19.93,0,0,1,38,11.91Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.91,268.55c-1.46,10.91-25.46,39.88-25.46,39.88s-15.5-34.28-14-45.19a19.93,19.93,0,0,1,39.5,5.31Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.94,134.37C55.84,142,92.62,150,92.62,150s-9-36.52-16.92-44.19a19.93,19.93,0,0,0-27.76,28.6Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.75,200.46c10.79,2.14,46-11.19,46-11.19S87.3,163.51,76.5,161.37a19.93,19.93,0,0,0-7.75,39.09Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.5,272c10.4-3.6,34-32.87,34-32.87s-36.68-8.39-47.07-4.79a19.93,19.93,0,1,0,13,37.66Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,313.19c10.86-1.8,39.1-26.65,39.1-26.65s-34.73-14.47-45.59-12.68A19.93,19.93,0,0,0,214,313.19Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.39,160.73c0,11-19.9,42.93-19.9,42.93s-19.94-31.91-19.95-42.91a19.93,19.93,0,1,1,39.85,0Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.07,210c-3.29,10.5-31.84,35-31.84,35S184.75,208.55,188,198a19.93,19.93,0,0,1,38,11.91Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.91,268.55c-1.46,10.91-25.46,39.88-25.46,39.88s-15.5-34.28-14-45.19a19.93,19.93,0,0,1,39.5,5.31Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.24,344.7s-9-93.18-62.88-142.74c-22.59-20.8-38.29-48-43.9-78.24a238.15,238.15,0,0,1-3.92-43.45",
    transform: "translate(-41.9 -21.46)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.79,48.84c4.12,10.21,34.53,32.36,34.53,32.36s6.55-37.05,2.44-47.26a19.93,19.93,0,0,0-37,14.9Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,117.69c9,6.33,46.57,8.4,46.57,8.4S177,91.43,168,85.1A19.92,19.92,0,1,0,145,117.69Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.31,213.77c11,.93,44.44-16.26,44.44-16.26s-30.13-22.53-41.1-23.45a19.93,19.93,0,1,0-3.34,39.71Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.15,279.61c10.66,2.76,46.55-8.52,46.55-8.52s-25.89-27.3-36.54-30.06a19.93,19.93,0,0,0-10,38.58Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.2,112.43c-4.45,10.06-35.59,31.17-35.59,31.17s-5.3-37.24-.85-47.31a19.93,19.93,0,1,1,36.44,16.14Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,190.11c-7.26,8.27-43.29,19.1-43.29,19.1s6.08-37.12,13.35-45.39A19.92,19.92,0,1,1,285,190.11Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,272.8c-5.76,9.38-39.44,26.14-39.44,26.14s-.28-37.62,5.48-47a19.93,19.93,0,0,1,34,20.86Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 408.16,
    cy: 837.18,
    rx: 111.53,
    ry: 14.52,
    fill: "#3b82f6",
    opacity: 0.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "5cfdbbb0-8197-4f02-a5fd-2740d54b5dec",
    "data-name": "floor flowers"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.88,
    cy: 836.06,
    rx: 33.88,
    ry: 5.8,
    fill: "#3b82f6",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.14,792.94s5.49,7.19-2.54,18-14.65,20-12,26.77c0,0,12.11-20.15,22-20.43S243,805.06,232.14,792.94Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.14,792.94a8.83,8.83,0,0,1,1.12,2.26c9.62,11.3,14.75,21.85,5.5,22.11-8.61.25-18.95,15.65-21.42,19.54a9.24,9.24,0,0,0,.29.89s12.11-20.15,22-20.43S243,805.06,232.14,792.94Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.35,802.1c0,2.53-.28,4.58-.63,4.58s-.64-2-.64-4.58.36-1.34.71-1.34S242.35,799.57,242.35,802.1Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.86,805.12c-2.22,1.21-4.16,1.94-4.33,1.63s1.5-1.54,3.72-2.75,1.34-.33,1.51,0S248.08,803.91,245.86,805.12Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.12,792.94s-5.49,7.19,2.54,18,14.65,20,12,26.77c0,0-12.11-20.15-22-20.43S192.28,805.06,203.12,792.94Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.12,792.94A8.83,8.83,0,0,0,202,795.2c-9.62,11.3-14.75,21.85-5.5,22.11,8.62.25,18.95,15.65,21.42,19.54a7.11,7.11,0,0,1-.29.89s-12.11-20.15-22-20.43S192.28,805.06,203.12,792.94Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.91,802.1c0,2.53.28,4.58.63,4.58s.64-2,.64-4.58-.36-1.34-.71-1.34S192.91,799.57,192.91,802.1Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.41,805.12c2.22,1.21,4.15,1.94,4.32,1.63s-1.5-1.54-3.72-2.75-1.34-.33-1.51,0S187.19,803.91,189.41,805.12Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.66,836.8s15.36-.48,20-3.77,23.62-7.24,24.77-1.95,23.08,26.29,5.74,26.43-40.29-2.7-44.91-5.51S194.66,836.8,194.66,836.8Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.47,855.67c-17.34.14-40.29-2.7-44.91-5.51-3.52-2.15-4.92-9.84-5.39-13.38l-.51,0s1,12.38,5.59,15.2,27.57,5.65,44.91,5.51c5,0,6.74-1.82,6.64-4.46C251.11,854.65,249.2,855.64,245.47,855.67Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.6,836.21s-42.28-2.55-37.29,27.08c0,0-1,5.23,3.75,7.61,0,0,.08-2.19,4.34-1.45a19.36,19.36,0,0,0,4.59.22,9.5,9.5,0,0,0,5.62-2.32h0s11.88-4.9,16.5-24.33c0,0,3.42-4.24,3.29-5.33l-7.14,3s2.44,5.15.52,9.43c0,0-.23-9.24-1.6-9-.28,0-3.71,1.78-3.71,1.78s4.2,9,1,15.48c0,0,1.2-11-2.34-14.83l-5,2.93s4.9,9.26,1.58,16.82c0,0,.85-11.59-2.63-16.11l-4.55,3.55s4.6,9.13,1.79,15.4c0,0-.36-13.49-2.78-14.51,0,0-4,3.51-4.59,5,0,0,3.15,6.62,1.2,10.12,0,0-1.2-9-2.19-9,0,0-4,6-4.38,10,0,0,.18-6.07,3.42-10.61a11.94,11.94,0,0,0-6.07,3.15s.62-4.21,7-4.58c0,0,3.28-4.52,4.16-4.79,0,0-6.4-.54-10.28,1.18,0,0,3.41-4,11.45-2.17l4.49-3.66s-8.42-1.16-12,.12c0,0,4.12-3.52,13.21-1l4.9-2.92s-7.19-1.55-11.47-1c0,0,4.52-2.44,12.9.2l3.5-1.57s-5.27-1-6.81-1.19-1.62-.59-1.62-.59a18.26,18.26,0,0,1,9.89,1.1S707.73,836.68,707.6,836.21Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 636.58,
    cy: 852.02,
    rx: 29.92,
    ry: 5.06,
    fill: "#3b82f6",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.53,837.79s-23.84-1.44-21,15.27a4.08,4.08,0,0,0,2.12,4.29s0-1.24,2.45-.82a11.67,11.67,0,0,0,2.58.13,5.47,5.47,0,0,0,3.17-1.31h0s6.7-2.77,9.31-13.72c0,0,1.92-2.39,1.85-3l-4,1.71s1.37,2.91.29,5.32c0,0-.13-5.21-.9-5.09-.16,0-2.09,1-2.09,1s2.36,5,.58,8.73c0,0,.67-6.23-1.32-8.37l-2.83,1.66s2.76,5.22.89,9.48c0,0,.48-6.54-1.49-9.08l-2.56,2s2.59,5.15,1,8.68c0,0-.21-7.61-1.57-8.18a15.64,15.64,0,0,0-2.59,2.79s1.78,3.74.68,5.71c0,0-.68-5.07-1.23-5.09,0,0-2.24,3.36-2.47,5.66a12.15,12.15,0,0,1,1.92-6,6.72,6.72,0,0,0-3.42,1.77s.35-2.38,4-2.58c0,0,1.84-2.55,2.34-2.7,0,0-3.61-.31-5.8.66,0,0,1.93-2.24,6.46-1.22l2.53-2.07s-4.75-.65-6.76.07c0,0,2.32-2,7.45-.54l2.75-1.64a24.71,24.71,0,0,0-6.46-.56s2.55-1.37,7.27.11l2-.88s-3-.59-3.83-.68-.92-.33-.92-.33a10.32,10.32,0,0,1,5.58.62S633.6,838.06,633.53,837.79Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 575.21,
    cy: 837.35,
    rx: 16.87,
    ry: 2.85,
    fill: "#3b82f6",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.9,802.38s-28.77-1.74-25.38,18.43a4.92,4.92,0,0,0,2.56,5.18s0-1.49,2.95-1a14.19,14.19,0,0,0,3.12.15,6.59,6.59,0,0,0,3.83-1.58h0s8.09-3.34,11.23-16.57c0,0,2.33-2.88,2.24-3.62l-4.86,2.07s1.66,3.51.36,6.42c0,0-.16-6.29-1.1-6.14-.18,0-2.52,1.21-2.52,1.21s2.86,6.11.7,10.54c0,0,.82-7.52-1.59-10.1l-3.42,2s3.34,6.3,1.08,11.45c0,0,.58-7.89-1.8-11l-3.1,2.41s3.14,6.21,1.23,10.48c0,0-.25-9.18-1.9-9.88,0,0-2.71,2.39-3.12,3.37,0,0,2.15,4.51.81,6.89,0,0-.81-6.11-1.48-6.14,0,0-2.7,4-3,6.83a14.71,14.71,0,0,1,2.32-7.22,8.13,8.13,0,0,0-4.13,2.14s.42-2.87,4.8-3.12c0,0,2.23-3.07,2.83-3.26,0,0-4.36-.36-7,.81,0,0,2.32-2.71,7.8-1.48l3.06-2.49s-5.74-.79-8.17.08c0,0,2.8-2.39,9-.65l3.33-2s-4.89-1-7.8-.67c0,0,3.07-1.66,8.78.13l2.38-1.06s-3.59-.71-4.64-.82-1.1-.4-1.1-.4a12.43,12.43,0,0,1,6.73.75S679,802.7,678.9,802.38Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 617.19,
    cy: 806.29,
    rx: 20.37,
    ry: 3.44,
    fill: "#3b82f6",
    opacity: 0.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "1cf578eb-5ffb-4cd7-95b8-45aaaddab7e0",
    "data-name": "browser"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1130,606.13V117H178.65V578.07c12.15,10.14,26.76,18.67,42,25.68q11.26,5.19,23,9.49h875Z",
    transform: "translate(-41.9 -21.46)",
    fill: "url(#6af09e6e-7617-4e7d-96c6-87d8d61cc5fb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.16,606.33V131H180.73v448.1c12.1,9.86,26.65,18.15,41.8,25q11.22,5,22.92,9.22h871.38Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.84,
    y: 96.93,
    width: 947.42,
    height: 25.14,
    fill: "#5a5773"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "6703b009-63cb-4af0-a0d7-9948e224c180",
    "data-name": "buttons"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 157.76,
    cy: 109.5,
    r: 6.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.26,
    cy: 109.5,
    r: 6.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.76,
    cy: 109.5,
    r: 6.5,
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "8c4e1fb4-b9ff-4530-b767-610e84618ea6",
    "data-name": "boxes"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380.95,
    y: 177.32,
    width: 156.5,
    height: 98.34,
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.26,
    y: 177.32,
    width: 156.5,
    height: 98.34,
    fill: "#5a5773",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.64,
    y: 177.32,
    width: 156.5,
    height: 98.34,
    fill: "#5a5773",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.26,
    y: 317.91,
    width: 156.5,
    height: 98.34,
    fill: "#5a5773",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.95,
    y: 317.91,
    width: 156.5,
    height: 98.34,
    fill: "#5a5773",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.64,
    y: 317.91,
    width: 156.5,
    height: 98.34,
    fill: "#5a5773",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.26,
    y: 458.49,
    width: 156.5,
    height: 98.34,
    fill: "#5a5773",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.95,
    y: 458.49,
    width: 156.5,
    height: 98.34,
    fill: "#5a5773",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.64,
    y: 458.49,
    width: 156.5,
    height: 98.34,
    fill: "#5a5773",
    opacity: 0.2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "2796dd85-6618-42ad-b8a0-d6b4cc80ab2d",
    "data-name": "woman"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M551.37,445.2S523.26,393.82,528,385.46,536.23,365,536.23,365s10.38-7.1,10.38-10,8.22-9.61,12.55-12.53,2.16-16.71,0-18.38-5.59-7.52-5.59-7.52,3-8.35,0-10.86.44-5,0-7.52,0-11.69,0-11.69c-3.51-4.88-7.4-7.16-11.06-8l-.32-1.32-1.85-7.79s9-17.25-5.6-26.28a24.4,24.4,0,0,0-3.23-1.7s0-.42-.08-1.13c-.2-2.58-.81-9-2.12-13.21-.76-2.42-1.75-4.05-3-3.68a2,2,0,0,0-.82.47,9.12,9.12,0,0,0-1.55,1.83s0,0,0,0a.41.41,0,0,1-.07.11,0,0,0,0,1,0,0,31.36,31.36,0,0,0-3.44,9.55,55.16,55.16,0,0,0-1,6,.08.08,0,0,0,0,0,33,33,0,0,0-1.67,3.71c-1.77,4.59-3.84,12.54-.07,18.42,3.2,5,7.51,11.87,10.64,16.87l.1.16.19.31-.33.21,0,.77.29,4.21L531,322.39a15.45,15.45,0,0,0-2.22-.47,20.17,20.17,0,0,0-3.23-.21c-2.11-8.29-7.9-16-9-24.66a22.87,22.87,0,0,1-.17-2.61c.09-5.45,1.45-10.92,1.34-16.36,0-1,0-2-.1-3v0c0-.27-.05-.55-.08-.83a24.59,24.59,0,0,0-13.37-18.63c-2.51-1.25-5.23-2.08-7.67-3.45-5.64-3.16-9.25-8.86-14.37-12.77-3.81-2.91-9.5-4.47-13.75-3a63.49,63.49,0,0,0-6.69,1.38h0a60.35,60.35,0,0,0-15.31,6.36c-.65.39-1.3.79-1.92,1.25a8.46,8.46,0,0,0-3.09,3.61,9.46,9.46,0,0,0-.48,3.89c0,.95,0,1.92.06,2.87-.28,16-17.52,28.38-18.94,44,0,.37-.06.74-.08,1.11,0,.11,0,.22,0,.34,0,.45,0,.91,0,1.37v0c0,.21,0,.41,0,.62s0,.42,0,.63c.25,6.85,3.81,13.23,4.46,20.05.06.61.09,1.21.1,1.82a30.24,30.24,0,0,1-1.77,9.18,26.87,26.87,0,0,0-6.21,2.52c-5.24,3.37-14.7,9.19-18.15,20.32a29.76,29.76,0,0,0-1.31,8.92,186.26,186.26,0,0,1-2.92,31.85,59.53,59.53,0,0,1-1.84,7.83,1.84,1.84,0,0,0-.06.77l-2.08,27-.37,4.75-.52,6.76s.15.41.37,1.1a31.8,31.8,0,0,1,.82,3.12,16.78,16.78,0,0,1,.27,7,4.82,4.82,0,0,1-1.46,2.57,1.08,1.08,0,0,0-.17.19c-.59.83-1.12,3.3-1.58,6.88-.18,1.4-.35,3-.52,4.66-1,10.65-1.62,26.59-2,39.77-.36,13-.49,23.27-.49,23.27a26.54,26.54,0,0,0,5.37,2.66c-.14.35-.29.71-.43,1.09a52.53,52.53,0,0,0-3.26,13.74c-.84,9.83,1.91,20.75,15.62,26.37a22.06,22.06,0,0,0,2.69.92c3,.8,5.21.58,6.84-.42,0,.59.07,1.16.1,1.73.14,2.44.26,4.67.32,6.54.43,11.7,3.33,32.16,3.33,32.16s1,8.36.13,10.86,0,12.53,0,12.53,3,5,0,7.52-3.89,15-3,16.71a.56.56,0,0,1,.05.19c.66,4.15-3.07,65.81-3.07,65.81s-3.53,9.44-6.34,19.24c-2.74,9.54-4.8,19.42-2.26,21.27,1.26.92,4.19,1.61,7.91,2.14,0,.41-.06.82-.1,1.24-.36,4.41-.93,9.16-1.75,10.36-1.19,1.7-2.44,14.88-3.05,22l-.06.79a73.7,73.7,0,0,0-3.22,9.34s-9.57,24-6.33,30.23a5.11,5.11,0,0,0,1.19,1.47h0a2.7,2.7,0,0,0,.31.28c4.61,3.69,16.16,4.46,20.35,4.63l-.16,5.94v.22h5.45v-.15c0-.75.12-4.19.3-8.79,0-.82.06-1.68.1-2.56,0-.69.07-1.39.1-2.11A37,37,0,0,0,426,834.76a58.58,58.58,0,0,1,2.1-15.48,43,43,0,0,1,2.77-7.55s1.7-9-.67-15.37a11.1,11.1,0,0,0-2-3.46c0-.21,0-.42,0-.64s0-.48,0-.73,0-.41,0-.63a57.69,57.69,0,0,1,1.28-12.82,1.42,1.42,0,0,1,0-.2c.08-.35.17-.68.26-1l.06-.22,1.77.06c5.43.15,9.42.15,9.42.15s4.33-22.14,3.9-31.74c0-.42,0-.86,0-1.3-.15-9.54,2.62-22.51,2.62-22.51L451,687.47s-1.73-5.86,0-10c1.07-2.58,3.28-7.37,4.82-10.67.72-1.53,1.29-2.73,1.53-3.25l.14-.28a6.47,6.47,0,0,1-1.54-.77h0c-1.41-.94-2.67-2.78,1.55-5.49,6.49-4.18,4.33-14.62,4.33-14.62s-1.91-3.76.34-7.1,0-15.87,0-15.87a52.47,52.47,0,0,0,4.44-10.45c1.61-5,5.68-29.45,7.6-41.24.63-3.87,1-6.37,1-6.37l.06.61.06.66h0l.54,5.57.07.74,1,10.53s2,27.68.75,38.53c0,.07,0,.14,0,.2a12.82,12.82,0,0,1-.73,3.29c-2.3,5.2-1.88,25.86-1.76,30.43,0,.37,0,.67,0,.92s-1.63,4.08-1.22,7.06h0a4.53,4.53,0,0,0,.79,2.1,5.32,5.32,0,0,1,.77,3.25v.1a11.81,11.81,0,0,1-.12,1.44,27.46,27.46,0,0,1-1.52,5.66s-2.32,6.1-1.44,9.29c0,0,0,0,0,0a2.94,2.94,0,0,0,.57,1.13,2.67,2.67,0,0,1,.33,1.2.43.43,0,0,0,0,.11c.81,6.73-1.28,36.44-2.52,52.7-.5,6.42-.86,10.74-.86,10.74l-3.43,35.5.34.24c.39.28,1.12.76,2.1,1.34,0,0,0,0,0,.08l-.15,1.07c-.49,3.42-1.15,7.4-1.87,10.44-.06.23-.11.45-.17.66a9.57,9.57,0,0,0-3.67,1.47c-7.28,12.93-4.06,23.18,0,26.16,1.15.84,1.93,3.19,2.45,6.11l1,12.89c0,.52,0,1,0,1.48a3.84,3.84,0,0,0,.19,1.18l.31,3.91.42,5.44h3.32V849h.18c5.24.18,13.69.4,17.37.11h.1c.39,0,.72-.07,1-.11a2.51,2.51,0,0,0,.58-.16c1.95-.94,6.81-14.72,2.43-17.85s-5.35-12-5.35-12c-.38-1.16-.76-2.26-1.15-3.31,0-.23,0-.45,0-.68-.12-4.29-.07-8.94.52-11.46.66-2.77,1-8.59,1.14-13.69,0-.39,0-.77,0-1.15v-.12a17.07,17.07,0,0,0,2.23-.73l.16-.07a15.71,15.71,0,0,0,3.73-2.21L506,731.33l1.29-6.31,7.35-35.89s-2.59-12.53,0-14.61c.95-.76,1.21-4,1.15-7.75-.1-6.56-1.15-14.81-1.15-14.81s3.46-5.43,5.2-8.77,0-12.11,0-12.11L523.25,611s3.9-23.81,13.41-43.86c7-14.75,2.54-54.58-2-75.78-.12-.55-.24-1.09-.36-1.61l0-.08c2.14-1.06,4.76-2.34,7.56-3.68l1.06-.5c3.55-1.67,7.31-3.39,10.68-4.82l.22-.09a74.58,74.58,0,0,1,7.43-2.78,12.47,12.47,0,0,1,2.28-.47C569.54,476.94,551.37,445.2,551.37,445.2ZM416.06,513.15l1.8,0c-.21.39-.41.79-.61,1.19-.12.24-.24.47-.35.71-.66,1.37-1.27,2.77-1.77,4.14.2-1.48.45-3.09.73-4.81C415.93,514,416,513.55,416.06,513.15Zm-4.86,26.07a.74.74,0,0,0,0-.14l-.15-.47c-.11-.32-.21-.64-.31-1q.93-.28,1.89-.63l.13,0c0,.11,0,.22,0,.33-.05.47-.11.94-.17,1.4h0a1,1,0,0,1,0,.18c0,.38-.09.74-.13,1.1-.09.72-.18,1.42-.26,2.09-.19-.63-.38-1.25-.58-1.86C411.42,539.89,411.31,539.55,411.2,539.22Z",
    transform: "translate(-41.9 -21.46)",
    fill: "url(#f366e0cb-9767-4f71-a21d-568f9afb6f3a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541,284.92l-10.8,3.82-3.92-6.5c-3-5-7.16-11.84-10.23-16.81-5.42-8.74,1.67-22.06,1.67-22.06S519,230,523.56,225.88s5.83,17.49,5.83,17.49c18.31,8.32,8.5,27.89,8.5,27.89l1.78,7.76Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#efb7b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541,284.92l-10.8,3.82-3.92-6.5,0-.57s6.19-4.25,13.41-2.65Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.56,328.72l5.41-4.58-2.71-41.22s14-9.58,24.36,5.41c0,0-.42,9.16,0,11.66s-2.91,5,0,7.49,0,10.83,0,10.83,3.29,5.83,5.37,7.49,4.17,15.41,0,18.32S544,353.7,544,356.61s-10,10-10,10L525.22,355Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#ff6484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.56,578.94c-20.18-8.56-15.7-29.47-11.9-40a54.46,54.46,0,0,1,2.67-6.24l11.32-6.87s2.31,5.89,4.78,13.79C419.16,558,425.75,587.09,406.56,578.94Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#efb7b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.3,769.73a34,34,0,0,0-3,8.42A60.81,60.81,0,0,0,430,792.48c.08,3.33.36,5.51.36,5.51l-22.48,15.46s.13-1.81.35-4.47c.58-7.08,1.79-20.22,2.93-21.92.79-1.18,1.34-5.92,1.69-10.32s.49-8.26.49-8.26S440.39,758.34,434.3,769.73Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#efb7b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.39,780.82s0,4.3-.16,9.3-.46,10.9-1.09,13.65c-.58,2.52-.62,7.15-.51,11.42.15,5,.51,9.5.51,9.5s-22.95-21.7-20.61-23.42c.63-.46,1.25-2.31,1.82-4.77.7-3,1.33-7,1.8-10.4.56-4.05.91-7.31.91-7.31Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#efb7b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.3,769.73a34,34,0,0,0-3,8.42,183.72,183.72,0,0,1-18.4-1.41c.34-4.3.49-8.26.49-8.26S440.39,758.34,434.3,769.73Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.39,780.82s0,4.3-.16,9.3c-7.16,1.83-14.52-1.83-18.08-4,.56-4.05.91-7.31.91-7.31Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.38,568.12c-9.16,20-12.91,43.72-12.91,43.72l-3.33,20s1.67,8.74,0,12.07-5,8.75-5,8.75,2.5,20.4,0,22.48,0,14.57,0,14.57l-8.33,42-11.66,54.12c-11.24,9.17-26.2-2.49-26.2-2.49l3.3-35.39s5-62,2.92-64.54S474,673,474,673s2.92-7.5.84-10.41.41-9.16.41-9.16-.83-25.4,1.67-31.23,0-41.89,0-41.89l-1-11.23-.58-6.22-.05-.61s-.38,2.49-1,6.35c-1.84,11.75-5.76,36.1-7.31,41.11a53.53,53.53,0,0,1-4.27,10.41s2.16,12.49,0,15.82-.33,7.08-.33,7.08,2.08,10.41-4.17,14.57,0,6.25,0,6.25-4.58,10-6.24,14.15,0,10,0,10l-3.33,33.72s-2.92,14.15-2.5,23.73-3.75,31.64-3.75,31.64-32.06,0-37-3.75S413.64,733,413.64,733s3.75-64.12,2.91-65.78,0-14.16,2.92-16.65,0-7.5,0-7.5-.83-10,0-12.49-.13-10.83-.13-10.83-2.79-20.4-3.2-32.06-2.5-37.88-2.5-37.88,2.18-16.22,2.51-23.94c.12-2.84,1.39-6.39,3-9.73a86.81,86.81,0,0,1,6.2-10.88S524,476.1,528.14,479c1.1.77,2.7,6,4.28,13.57C536.82,513.72,541.12,553.42,534.38,568.12Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.7,
    cy: 263.46,
    r: 28.73,
    fill: "#a1616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.42,492.59c-3.31,1.7-5.53,2.87-5.53,2.87S480.26,517.53,467,516.28c-10.26-1-36.45-.43-47.86-.15a86.81,86.81,0,0,1,6.2-10.88S524,476.1,528.14,479C529.24,479.79,530.84,485,532.42,492.59Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.61,330.8S427,335,420.72,339.12,402,351.2,402,368.27s-2.91,34.56-4.58,39.55,26.23,45.38,26.23,45.38l-10,61.21s40-1.25,53.32,0,59.93-20.82,59.93-20.82,27.48-14.57,33.31-15-11.66-32.06-11.66-32.06S521.48,395.33,526.06,387,534,366.6,534,366.6l-5-42.46s-7.49-2.5-13.74,2.08-27.48,2.08-27.48,2.08Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#ff6484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.44,404.91,398,407.82,395.11,447s3.75,10.41,0,13.74-4.58,74.53-4.58,74.53,12.08,8.74,26.23,2.08c0,0-2.08-7.91,4.17-36.64s6.24-43.3,6.24-43.3,0-35.81,2.92-41.64,0-20.4,0-20.4-5.83-7.91-5.42-10.82S408.44,404.91,408.44,404.91Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.43,539.65a26.59,26.59,0,0,1-18.77-.68,54.46,54.46,0,0,1,2.67-6.24l11.32-6.87S411,531.75,413.43,539.65Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.81,404.91l-10.41,2.91L394.49,447s3.75,10.41,0,13.74-4.58,74.53-4.58,74.53S402,544,416.14,537.31c0,0-2.08-7.91,4.16-36.64s6.25-43.3,6.25-43.3,0-35.81,2.91-41.64,0-20.4,0-20.4-5.83-7.91-5.41-10.82S407.81,404.91,407.81,404.91Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#ff6484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.4,411.15s-5.41,46.63-21.24,55.38C493.16,466.53,528.55,456.54,514.4,411.15Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.88,415.32s19.56,9.57,15,16.23S434.88,415.32,434.88,415.32Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.88,434.47s12.49,12.91,10,17.49S434.88,434.47,434.88,434.47Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.63,327.47s4.9,8.32,5.37,13.74S535.63,327.47,535.63,327.47Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.63,316.23s2.46-2.09,8.74,0S535.63,316.23,535.63,316.23Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.59,559.58a57.9,57.9,0,0,1-30.45-3.9l-5.25,13.44-.58-6.22c.86-5.22,2.53-10.81,5.83-12.22C481.14,550.68,492.7,559.89,511.59,559.58Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.18,577.07s25.61,5.31,32.79,4.37Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.84,583.78s10.93-.47,16.39,1.72Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.09,588.31a98,98,0,0,0,15.14,2Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.46,645.61c.47-.31,21.86-5.31,24.52-1.72Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.46,652.17s18.58-2.19,19.05,0S429.46,652.17,429.46,652.17Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.46,658.1S449.29,654,451.63,655,429.46,658.1,429.46,658.1Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.4,798l-22.48,15.46s.13-1.81.35-4.47c5-12.3,11.51-18.79,11.51-18.79,5.07-1.32,8.27-.1,10.26,2.29C430.12,795.81,430.4,798,430.4,798Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.59,811.89a55.79,55.79,0,0,0-4.69,23,35.67,35.67,0,0,1-4.76,18.51,18.24,18.24,0,0,1-1.58,2.26s-15.62-.13-21.09-4.66A5.41,5.41,0,0,1,399,849.2c-3.13-6.24,6.09-30.13,6.09-30.13,4.84-18.42,14.67-28.26,14.67-28.26C437.27,786.28,432.59,811.89,432.59,811.89Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.14,853.35a18.24,18.24,0,0,1-1.58,2.26s-15.62-.13-21.09-4.66c2.69-8.9,11.27-35.83,15.29-31.25C419.54,824,422.17,844.69,423.14,853.35Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,821.37l-1.09,40.34h5.24s.85-35.39,3.19-40.34S421,821.37,421,821.37Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.14,824.69s-22.95-21.7-20.61-23.42c.63-.46,1.25-2.31,1.82-4.77,4.41-.77,12,1.07,18.28,18.69C485.78,820.19,486.14,824.69,486.14,824.69Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.57,848.89a2.33,2.33,0,0,1-.55.16c-2.7.47-12.65.2-18.22,0a3.94,3.94,0,0,1-3.81-3.93c0-1.5,0-3.33-.12-5.28-.26-6.16-1-13.49-3.21-15.14-3.91-3-7-13.18,0-26.07,0,0,13.42-10.25,23.1,20.56,0,0,.94,8.79,5.15,11.91S491.45,848,489.57,848.89Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489,849.05c-2.7.47-12.65.2-18.22,0a3.94,3.94,0,0,1-3.81-3.93c0-1.5,0-3.33-.12-5.28,1.69-7.46,4.12-15.14,7.25-16.89C474.12,822.94,483.59,821.87,489,849.05Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.46 800.58 425.98 834.15 429.18 834.15 429.18 797.72 423.46 800.58",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.18,239.14a57.42,57.42,0,0,0-25.62,8.23c-2,1.21-4,2.68-4.83,4.85-.72,1.88-.42,4-.39,6,.27,17.22-18.93,30.25-18.33,47.46.24,6.83,3.67,13.19,4.3,20,1.05,11.36-5.67,21.81-12.11,31.22a25.86,25.86,0,0,0,18.25-6.05A138.39,138.39,0,0,1,437,420.6l9.21,0a7,7,0,0,1,2.69.33,6.76,6.76,0,0,1,2.13,1.59c8.61,8.57,14.38,21.24,11.09,32.94l19.6-7.35c4.69-1.76,9.45-3.55,13.53-6.45s7.5-7.11,8.36-12.05c.53-3,.36-6.58,2.83-8.32a15.4,15.4,0,0,1,3.86-1.43c5.38-1.9,7.76-8.12,8.86-13.72a79,79,0,0,0,1.25-20.87c-.87-11.7-4.33-23.58-1.48-35,1.61-6.41,5.19-12.38,5.48-19,.47-10.91-8.06-20.31-9.33-31.16-.89-7.56,1.84-15.21.95-22.77a24.46,24.46,0,0,0-12.87-18.57c-2.41-1.24-5-2.07-7.38-3.44-5.43-3.15-8.9-8.82-13.83-12.72s-13.14-5.37-16.85-.3Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.18,237.89a57.42,57.42,0,0,0-25.62,8.23c-2,1.21-4,2.68-4.83,4.85-.72,1.88-.42,4-.39,6,.27,17.22-18.93,30.25-18.33,47.47.24,6.82,3.67,13.18,4.3,20,1.05,11.36-5.67,21.81-12.11,31.23a26,26,0,0,0,18.25-6.05A138.34,138.34,0,0,1,437,419.35l9.21,0a7,7,0,0,1,2.69.34,6.58,6.58,0,0,1,2.13,1.58c8.61,8.58,14.38,21.24,11.09,32.94l19.6-7.35c4.69-1.76,9.45-3.55,13.53-6.45s7.5-7.11,8.36-12.05c.53-3,.36-6.58,2.83-8.32a15.4,15.4,0,0,1,3.86-1.43c5.38-1.9,7.76-8.12,8.86-13.72A79,79,0,0,0,520.44,384c-.87-11.7-4.33-23.58-1.48-35,1.61-6.41,5.19-12.38,5.48-19,.47-10.91-8.06-20.31-9.33-31.16-.89-7.56,1.84-15.2.95-22.77a24.48,24.48,0,0,0-12.87-18.57c-2.41-1.24-5-2.07-7.38-3.43-5.43-3.16-8.9-8.83-13.83-12.73s-13.14-5.37-16.85-.3Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#925978"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.32,252.81a11.12,11.12,0,0,0-.06,1.16C442.29,253.59,442.31,253.2,442.32,252.81Z",
    transform: "translate(-41.9 -21.46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515,292.84c.36-5.3,1.54-10.62,1.1-15.9C515.77,282.24,514.59,287.56,515,292.84Z",
    transform: "translate(-41.9 -21.46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.31,319.19c-.58-6.2-3.47-12-4.15-18.19a22.8,22.8,0,0,0-.15,3.42c.24,6.75,3.59,13.06,4.27,19.78A27,27,0,0,0,428.31,319.19Z",
    transform: "translate(-41.9 -21.46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519,343.82a42.88,42.88,0,0,0-1,12.42,37.65,37.65,0,0,1,1-7.21c1.61-6.41,5.19-12.38,5.48-19a20.61,20.61,0,0,0-.16-3.52C523.54,332.46,520.43,338,519,343.82Z",
    transform: "translate(-41.9 -21.46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.45,344.36a26,26,0,0,1-14.76,6c-1.14,1.78-2.32,3.52-3.49,5.24a26,26,0,0,0,18.25-6.05A138,138,0,0,1,440.27,387,138.31,138.31,0,0,0,434.45,344.36Z",
    transform: "translate(-41.9 -21.46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.19,399.65c-1.1,5.6-3.48,11.82-8.86,13.71a15,15,0,0,0-3.86,1.44c-2.47,1.74-2.3,5.34-2.83,8.32-.86,4.94-4.27,9.14-8.36,12s-8.84,4.7-13.53,6.46l-18.7,7a25.81,25.81,0,0,1-.9,5.55l19.6-7.35c4.69-1.76,9.45-3.55,13.53-6.45s7.5-7.11,8.36-12.05c.53-3,.36-6.58,2.83-8.32a15.4,15.4,0,0,1,3.86-1.43c5.38-1.9,7.76-8.12,8.86-13.72a78.42,78.42,0,0,0,1.41-17.7A78.3,78.3,0,0,1,519.19,399.65Z",
    transform: "translate(-41.9 -21.46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.06,416a6.61,6.61,0,0,0-2.13-1.59,7.15,7.15,0,0,0-2.69-.34l-8.17,0c-.32,1.74-.66,3.48-1,5.21l9.21,0a7,7,0,0,1,2.69.34,6.58,6.58,0,0,1,2.13,1.58c6.3,6.28,11.07,14.74,11.89,23.42C464,434.24,458.62,423.56,451.06,416Z",
    transform: "translate(-41.9 -21.46)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M405.37,450.08s7.44-3.12,9.1,0S405.37,450.08,405.37,450.08Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,455.43s7.44-3.12,9.11,0S408,455.43,408,455.43Z",
    transform: "translate(-41.9 -21.46)",
    opacity: 0.1
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "5f43f84a-a268-4bb5-a31a-6b0c09aee323",
    "data-name": "leaves"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M869.11,51.68s-38.05-2.29-33.56,24.37c0,0-.89,4.71,3.38,6.85,0,0,.07-2,3.9-1.31a17.51,17.51,0,0,0,4.13.2A8.57,8.57,0,0,0,852,79.7h0s10.69-4.41,14.85-21.89c0,0,3.08-3.82,3-4.8l-6.42,2.75s2.19,4.63.46,8.48c0,0-.2-8.32-1.44-8.12-.25,0-3.33,1.6-3.33,1.6s3.77,8.07.92,13.94c0,0,1.08-9.94-2.1-13.35L853.4,61s4.41,8.33,1.42,15.13c0,0,.77-10.43-2.37-14.49l-4.1,3.19S852.5,73,850,78.64c0,0-.33-12.15-2.51-13.06,0,0-3.58,3.16-4.12,4.46,0,0,2.83,6,1.07,9.1,0,0-1.08-8.08-2-8.12,0,0-3.57,5.36-3.94,9a19.51,19.51,0,0,1,3.07-9.55,10.67,10.67,0,0,0-5.46,2.84s.55-3.79,6.34-4.13c0,0,2.95-4.06,3.74-4.31,0,0-5.76-.48-9.25,1.07,0,0,3.07-3.58,10.31-2l4-3.3s-7.58-1-10.8.11c0,0,3.7-3.16,11.89-.86l4.4-2.63s-6.46-1.4-10.31-.89c0,0,4.06-2.19,11.6.18l3.15-1.41s-4.74-.93-6.12-1.08-1.46-.53-1.46-.53a16.36,16.36,0,0,1,8.89,1S869.22,52.1,869.11,51.68Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.88,30.06s-32,20.71-12.59,39.52c0,0,2.07,4.32,6.78,3.52,0,0-1.12-1.64,2.37-3.37a17.36,17.36,0,0,0,3.45-2.29,8.61,8.61,0,0,0,2.83-4.67h0s6-9.9-1-26.44c0,0,.22-4.9-.46-5.62l-3.54,6s4.51,2.43,5.4,6.55c0,0-5.09-6.57-6-5.68-.18.18-1.74,3.27-1.74,3.27s7.83,4.26,9,10.67c0,0-5-8.65-9.61-9.5l-2.08,4.8s8.5,4.1,10.12,11.35c0,0-5.57-8.86-10.5-10.27l-1.4,5s8.2,4.16,9.51,10.2c0,0-7.46-9.58-9.76-9,0,0-1,4.66-.68,6,0,0,5.82,3.12,6.26,6.7,0,0-5.66-5.87-6.39-5.38,0,0,.3,6.43,2.17,9.61a19.53,19.53,0,0,1-3.18-9.51,10.7,10.7,0,0,0-2.72,5.52s-1.8-3.38,2.67-7.08c0,0,0-5,.45-5.69,0,0-4.92,3-6.82,6.34,0,0,.36-4.7,7.15-7.68l1.3-5.05s-6.72,3.66-8.63,6.49c0,0,1.11-4.74,9.06-7.74l2-4.73s-6,2.71-8.84,5.4c0,0,2-4.18,9.46-6.73l1.7-3s-4.37,2.06-5.57,2.76-1.49.44-1.49.44a16.39,16.39,0,0,1,7.75-4.47S815.22,30.34,814.88,30.06Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.18,54.19s-19.13,33,6.7,40.93c0,0,3.81,2.91,7.64,0,0,0-1.73-.94.59-4.07a17.51,17.51,0,0,0,2-3.6,8.64,8.64,0,0,0,.41-5.45h0s.85-11.54-12.9-23.11c0,0-2-4.46-3-4.79l-.43,7s5.12.12,7.79,3.39c0,0-7.52-3.55-7.9-2.36-.08.24-.07,3.7-.07,3.7S776,66.1,780,71.28c0,0-8.4-5.43-12.87-4.11l.32,5.22s9.43-.2,14.16,5.53c0,0-9-5.37-14-4.39l1,5.09s9.2,0,13.1,4.78c0,0-11-5.16-12.79-3.63,0,0,1.21,4.62,2.13,5.69,0,0,6.6.14,8.62,3.13,0,0-7.71-2.67-8.14-1.89,0,0,3.19,5.59,6.3,7.57a19.53,19.53,0,0,1-7.15-7,10.71,10.71,0,0,0,.08,6.15s-3.14-2.19-.84-7.52c0,0-2.3-4.46-2.17-5.27,0,0-3,4.93-3.2,8.74,0,0-1.82-4.35,2.88-10.08l-1.13-5.1s-4.33,6.31-4.75,9.7c0,0-1.16-4.73,4.57-11l-.38-5.11s-4.14,5.15-5.42,8.82c0,0-.14-4.62,5.37-10.29l.15-3.45s-3,3.81-3.71,5S761,68.88,761,68.88a16.46,16.46,0,0,1,4.88-7.51S766.6,54.28,766.18,54.19Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6",
    opacity: 0.1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M930.43,430.37a14.31,14.31,0,1,0,14.31,14.31A14.35,14.35,0,0,0,930.43,430.37ZM888.59,318.08v14.31H902.9l25.76,52.18L917.89,402.1a13.76,13.76,0,0,0-1.79,6.8c0,9.58,6.55,14.31,15.43,14.31h83.67V409.45H933.28a1.69,1.69,0,0,1-1.79-1.79,9,9,0,0,1,.76-1.78l7.15-11.29h53.31a14,14,0,0,0,12.52-7.51L1031,342.77a8.31,8.31,0,0,0,.72-3.58,6.88,6.88,0,0,0-7.16-6.8H918.65l-6.8-14.31Zm112.29,112.29a14.31,14.31,0,1,0,14.32,14.31A14.35,14.35,0,0,0,1000.88,430.37Z",
    transform: "translate(-41.9 -21.46)",
    fill: "#3b82f6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "940.67 336.21 928.67 336.21 928.67 324.21 919.67 324.21 919.67 336.21 907.67 336.21 907.67 345.21 919.67 345.21 919.67 357.21 928.67 357.21 928.67 345.21 940.67 345.21 940.67 336.21",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.f10fe2442d857cbbcba99772c8ab89c8.svg";
export { ForwardRef as ReactComponent };